import { AuthProvider } from '@sdk/authentication/AuthContext';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';

import { UserSettingsProvider } from '@web/settings/UserSettingsContext';
import { UserOrgSettingsProvider } from '@web/settings/UserOrgSettingsContext';
import BackTooSoonModal from '@web/timeClock/BackTooSoonModal/BackTooSoonModal';
import { Props } from '@web/timeClock/BackTooSoonModal/backTooSoonModal.types';

type PropsWithContext = Props & {
  Authentication: {
    user: AuthUserType;
  };
};

const BackTooSoonModalAngular = ({
  shift,
  shouldShow,
  onClose,
  Authentication,
}: PropsWithContext) => (
  <AuthProvider currentUser={Authentication.user}>
    <UserSettingsProvider settings={Authentication.user.settings}>
      <UserOrgSettingsProvider settings={Authentication.user.orgSettings}>
        <BackTooSoonModal shift={shift} shouldShow={Boolean(shouldShow)} onClose={onClose} />
      </UserOrgSettingsProvider>
    </UserSettingsProvider>
  </AuthProvider>
);

export default {
  ReactComponent: BackTooSoonModalAngular,
  dependencies: ['Authentication'],
  bindings: {
    shift: '<',
    shouldShow: '<',
    onClose: '&',
  },
};
